module.exports = __webpack_public_path__ + "img/pride_logo.37325eee.png";